import { CDMVersion } from '@/enums/CDMVersion';
import { EntityCommonData, Nullable } from '@prometheus/types';

export interface VocabularyBundle {
  id: string;
  timestamp: string;
  name: string;
  description: string;
  externalId: number;
  lastUpdated: string;
  link: string;
  cdmVersion: CDMVersion;
  releaseVersion: string;
  status: string;
  vocabularies: Array<VocabularyInfo>;
  downloaded: boolean;
  downloadStatus: Nullable<VocabularyBundleStatus>;
  errorReason: ErrorReason;
  user: string;
  downloadable: boolean;
  externalStatus: unknown;
  inProgress: boolean;
  updatable: boolean;
  newVersionInfo: {
    releaseVersion: string;
  };
}
export interface VocabBundleWithState extends VocabularyBundle {
  inProgress: boolean;
  updatable: boolean;
  downloadable: boolean;
}

export interface VocabularyInfo extends EntityCommonData {
  available: boolean;
  code: string;
  externalId: number;
  includedByDefault: boolean;
  lastUpdated: string;
  name: string;
  omopRequired: boolean;
  required: boolean;
  url: string;
}

export enum VocabularyBundleStatus {
  REQUEST_EXISTS = 'REQUEST_EXISTS',
  GENERATION = 'GENERATION',
  DOWNLOADING = 'DOWNLOADING',
  DOWNLOADED = 'DOWNLOADED',
  FAILED = 'FAILED',
  REQUEST_NEW = 'REQUEST_NEW',
  FAILED_NEW = 'FAILED_NEW',
}

export enum ErrorReason {
  GENERATION_FAILURE = 'GENERATION_FAILURE',
  NOT_EXISTS = 'NOT_EXISTS',
  GENERATION_NOT_STARTED = 'GENERATION_NOT_STARTED',
  DOWNLOAD_FAILURE = 'DOWNLOAD_FAILURE',
  API_COMMUNICATION_ERROR = 'API_COMMUNICATION_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}
